<template>
	<!-- <div style="overflow-x: scroll; width: 100%"> -->
	<div :class="isSmall ? 'flex1 dashboard-container' : 'flex1 dashboard-container small '" :key="key" style="" id="zong">
		<div class="area-center">
			<center-map :outParams="params" @change-type="isSmall = !isSmall" @mapOrigin="getDateMap" />
		</div>
		<!-- 辖区风险指数放射图 -->
		<div class="area-sidebar1 box-content" style="position: relative">
			<div class="box-header">辖区风险指数</div>
			<div class="box-container">
				<div style="width: 100%; height: 100%" ref="radarCharts" v-if="radarFlag" :style="radarFlag ? 'z-index: 999;' : 'z-index:0'"></div>
				<div style="width: 100%; height: 100%" ref="radarCharts1" v-if="!radarFlag" :style="radarFlag ? 'z-index:0' : 'z-index: 999;'"></div>
			</div>
		</div>
		<!-- 重点场所 -->
		<div class="area-sidebar2 box-content">
			<div class="box-header1">
				<span>重点场所</span>
				<span style="font-size: 15px; line-height: 18px; cursor: pointer" @click="changeBoxContainerFlag">
					<el-image
						style="width: 18px; height: 18px; vertical-align: bottom"
						:src="boxContainerFlag ? require('@/assets/img/analysis/keyLocationMore.png') : require('@/assets/img/analysis/boxfullwhite.png')"
						alt=""
					></el-image>
					{{ boxContainerFlag ? "单位列表" : "单位展示" }}
				</span>
			</div>
			<div class="box-container" :style="boxContainerFlag ? '' : 'display:none'">
				<div class="flex flex1" style="align-items: center">
					<div class="half">
						<el-image :src="require('@/assets/img/analysis/red-build.png')" alt="" />
					</div>
					<div class="half text-center">
						<div class="box-title">{{ mainCompanyNum.companyName }}</div>
						<div class="box-text">
							综合得分：<span class="yellow">{{ mainCompanyNum.score }}</span>
						</div>
					</div>
				</div>
				<div class="three">
					<div>
						<span class="baby-blue">火警总数</span>&nbsp;<span>{{ mainCompanyNum.fireAlarm }}</span>
					</div>
					<div>
						<span class="dark-yellow">预案完善情况</span>&nbsp;<span>{{ mainCompanyNum.planImprovement ? "已完善" : "未完善" }}</span>
					</div>
					<div>
						<span class="dark-yellow">用传在线状态</span>&nbsp;<span>{{ mainCompanyNum.transmissionState ? "在线" : "离线" }}</span>
					</div>
				</div>
			</div>
			<div class="box-containerSearch" :style="boxContainerFlag ? 'display:none' : ''">
				<el-input v-model="inputSearch" class="searchinput" placeholder="请输入单位名称" prefix-icon="el-icon-search" @change="getKeyComponyNum"> </el-input>
				<div class="regional_table">
					<el-table :data="tableData" height="200" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
						<el-table-column prop="rankNum" label="排名" width="60"> </el-table-column>
						<el-table-column prop="cname" label="单位名称" width="260"> </el-table-column>
						<el-table-column prop="score" label="分数"> </el-table-column>
					</el-table>
				</div>

				<!-- background="true" -->
				<!-- @size-change="handleSizeChange()"
          @current-change="handleCurrentChange()"
           -->
				<el-pagination
					:total="countPage"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					layout="prev, pager, next"
					class="fenye"
					:current-page="currentPage"
					:page-size="pageSize"
					:pager-count="5"
				>
				</el-pagination>
			</div>
		</div>
		<!-- 设备在线统计 -->
		<div class="area-sidebar3 box-content">
			<!-- <span class="box-more">更多</span> -->
			<div class="box-header">设备在线统计</div>
			<div class="box-container">
				<div class="flex flex1" style="align-items: center">
					<div class="half center" style="height: 100%">
						<div style="width: 100%; height: 100%" ref="scaleRingCharts"></div>
					</div>
					<div class="half text-center">
						<div class="ring-right">
							<div class="ring-content">
								<div class="flex ring-label"><span class="ring-box ring-color1"></span><span>水系统监测</span></div>
								<div class="ring-text">
									<span class="ring-text-color1">{{ mainCompany.deviceCount.waterCount }}</span>
									个
								</div>
							</div>
							<div class="ring-content">
								<div class="flex ring-label"><span class="ring-box ring-color2"></span><span>用传</span></div>
								<div class="ring-text">
									<span class="ring-text-color2">{{ mainCompany.deviceCount.transmissionCount }}</span>
									个
								</div>
							</div>
							<div class="ring-content">
								<div class="flex ring-label"><span class="ring-box ring-color3"></span><span>电气监测</span></div>
								<div class="ring-text">
									<span class="ring-text-color3">{{ mainCompany.deviceCount.electricalCount }}</span>
									个
								</div>
							</div>
							<div class="ring-content">
								<div class="flex ring-label"><span class="ring-box ring-color4"></span><span>气体监测</span></div>
								<div class="ring-text">
									<span class="ring-text-color4">{{ mainCompany.deviceCount.gasCount }}</span>
									个
								</div>
							</div>
							<div class="ring-content">
								<div class="flex ring-label"><span class="ring-box ring-color5"></span><span>其他网关</span></div>
								<div class="ring-text">
									<span class="ring-text-color5">{{ mainCompany.deviceCount.otherCount }}</span>
									个
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 报警单位排名 -->
		<div class="area-sidebar4 box-content">
			<div class="box-header">报警单位排名</div>
			<div class="box-container">
				<div class="battery-header" v-loading="evenClassLoading">
					<span @click="params.evenClass = 1" :style="this.evenFlag == 1 ? 'background-color: rgb(137, 137, 138);' : ''">火警</span
					><span @click="params.evenClass = 2" :style="this.evenFlag == 2 ? 'background-color: rgb(137, 137, 138);' : ''">水系统</span
					><span @click="params.evenClass = 3" :style="this.evenFlag == 3 ? 'background-color: rgb(137, 137, 138);' : ''">电气检测</span
					><span
						:style="
							this.evenFlag == 4
								? 'float: right; display: flex; justify-content: center;background-color: rgb(137, 137, 138)'
								: 'float: right; display: flex; justify-content: center;'
						"
						@click="$refs['batteryDate'].focus()"
					>
						选择时间
						<!-- @change="confirmTime" -->
						<el-date-picker
							ref="batteryDate"
							style="height: 0; padding: 0; width: 0; visibility: hidden"
							v-model="batteryDate"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						>
						</el-date-picker
					></span>
				</div>
				<div class="battery-charts-header"><span>单位名称</span><span>报警数量</span></div>
				<div class="flex1">
					<div style="width: 100%; height: 100%" ref="batteryBarCharts"></div>
				</div>
			</div>
		</div>
		<!-- 单位安全等级分布 -->
		<div class="area-sidebar5 box-content">
			<div class="box-header">单位安全等级分布</div>
			<div style="position: relative">
				<div>图例</div>
				<div class="safe-legend">
					<div>5级<span class="legend-text-color1">0-20</span></div>
					<div>4级<span class="legend-text-color2">20-40</span></div>
					<div>3级<span class="legend-text-color3">40-60</span></div>
					<div>2级<span class="legend-text-color4">60-80</span></div>
					<div>1级<span class="legend-text-color5">80-100</span></div>
				</div>
			</div>
			<div class="box-container">
				<div style="width: 100%; height: 100%; margin-left: 10px" ref="funnelCharts"></div>
			</div>
		</div>
		<!-- 各区评估维保率 -->
		<div class="area-sidebar6 box-content">
			<div class="box-header">
				各区评估维保率
				<span
					@click="dialogVisible = true"
					style="
            font-size: 14px;
            position: absolute;
            right: 150px;
            cursor: pointer;
          "
				>
					选择时间
				</span>
			</div>

			<div class="box-container">
				<div style="width: 100%; height: 100%" ref="maintenanceCharts"></div>
			</div>
		</div>
		<!-- 物联设备检测 -->
		<div class="area-sidebar7 box-content">
			<div class="box-header">物联设备检测</div>
			<!-- params.deviceType -->
			<div class="battery-header" v-loading="deviceTypeLoading">
				<span @click="onTheMapFlag ? (params.deviceType = 2) : (params2.deviceType = 2)" :style="this.slectedFlag == 2 ? 'background-color: rgb(137, 137, 138);' : ''">水系统</span>
				<span @click="onTheMapFlag ? (params.deviceType = 3) : (params2.deviceType = 3)" :style="this.slectedFlag == 3 ? 'background-color: rgb(137, 137, 138);' : ''">电气</span>
				<span @click="onTheMapFlag ? (params.deviceType = 4) : (params2.deviceType = 4)" :style="this.slectedFlag == 4 ? 'background-color: rgb(137, 137, 138);' : ''"
					>气体检测
				</span>
				<span @click="onTheMapFlag ? (params.deviceType = 5) : (params2.deviceType = 5)" :style="this.slectedFlag == 5 ? 'background-color: rgb(137, 137, 138);' : ''">用传</span>
				<span @click="onTheMapFlag ? (params.deviceType = 6) : (params2.deviceType = 6)" :style="this.slectedFlag == 6 ? 'background-color: rgb(137, 137, 138);' : ''">其他</span>
			</div>
			<div class="box-container">
				<div style="width: 100%; height: 100%" ref="equipmentCharts"></div>
			</div>
		</div>
		<!-- 消防评估汇总图 -->
		<div class="area-sidebar8 box-content">
			<div class="box-header">
				消防评估汇总图
				<span
					style="
            font-size: 15px;
            line-height: 18px;
            cursor: pointer;
            position: absolute;
            right: 80px;
          "
					@click="changeFireAssessmentFlag"
				>
					<el-image
						style="width: 18px; height: 18px; vertical-align: bottom"
						:src="fireAssessmentFlag ? require('@/assets/img/analysis/keyLocationMore.png') : require('@/assets/img/analysis/boxfullwhite.png')"
						alt=""
					></el-image>
					{{ fireAssessmentFlag ? "单位列表" : "单位展示" }}
				</span>
			</div>
			<!-- :style="fireAssessmentFlag ? '' : 'display:none'" -->
			<div class="box-container" v-if="fireAssessmentFlag">
				<!-- <div style="width: 100%; height: 100%" ref="firePieCharts"></div> -->
				<div style="width: 100%; height: 100%" ref="firePieCharts" v-if="fireFightingFlag" :style="fireFightingFlag ? 'z-index: 999;' : 'z-index:0'" key="firePieCharts"></div>
				<div style="width: 100%; height: 100%" ref="firePieCharts1" v-if="!fireFightingFlag" :style="fireFightingFlag ? 'z-index:0' : 'z-index: 999;'" key="firePieCharts1"></div>
			</div>
			<!-- :style="fireAssessmentFlag ? 'display:none' : ''" -->
			<div class="fireList" v-if="!fireAssessmentFlag">
				<div class="regional_table">
					<el-table :data="fireAssessmentTable" height="200" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
						<el-table-column prop="companyName" label="单位名称" width="300"> </el-table-column>
						<el-table-column prop="" label="详情">
							<template slot-scope="scope">
								<router-link
									:to="{
										name: '/score/detail',
										path: '/score/detail',
										query: {
											c_num: scope.row.companyNum,
											name: scope.row.companyName,
											type: 1,
										},
									}"
									tag="span"
								>
									<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
								</router-link>
							</template></el-table-column
						>
					</el-table>
				</div>

				<!-- background="true" -->
				<!-- @size-change="handleSizeChange()"
          @current-change="handleCurrentChange()"
           -->
				<el-pagination
					:total="fireAssessmentCountPage"
					@size-change="fireHandleSizeChange"
					@current-change="fireHandleCurrentChange"
					layout="prev, pager, next"
					class="fenye"
					:current-page="fireAssessmentcurrentPage"
					:page-size="fireAssessmentpageSize"
				>
				</el-pagination>
			</div>
		</div>
		<el-dialog title="更改时间" :visible.sync="dialogVisible" width="30%" style="position: absolute; top: 50%; margin-top: -100px">
			<YearRangePicker @change="changeStartEnd" v-model="yearsList" :clearData="clearInputData"> </YearRangePicker>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭弹窗</el-button>
				<el-button type="primary" @click="handleClose">时间重置</el-button>
			</span>
		</el-dialog>
	</div>
	<!-- </div> -->
</template>

<script>
	import centerMap from "./center-map.vue";
	import YearRangePicker from "./YearRangePicker.vue";
	import {
		radarOption,
		scaleRingOption,
		batteryBarOoption,
		funnelOption,
		maintenanceOption,
		firePieOption,
		equipmentOption,
		radarOption1,
		firePieOption1,
		radiateOption, //辖区风险放射图
		unitSafetyOption, //单位安全条形图
	} from "../api/echartsOptions.js";
	let timer = null;
	export default {
		components: { YearRangePicker, centerMap },
		data() {
			return {
				radarFlag: false, //辖区风险指数柱状图雷达图切换按钮
				inputSearch: "", //重点场所搜索值
				boxContainerFlag: true, //重点场所默认显示图
				fireAssessmentFlag: true, //消防评估默认显示图
				fireFightingFlag: true,
				isSmall: false,
				key: 0,
				radarCharts: null,
				scaleRingCharts: null,
				batteryBarCharts: null,
				funnelCharts: null,
				maintenanceCharts: null,
				firePieCharts: null,
				equipmentCharts: null,
				scaleRingColorList: [
					new this.$echarts.graphic.LinearGradient(1, 1, 0, 0, [
						{ offset: 0, color: "#E4FBFF" }, //开始的颜色
						{ offset: 1, color: "#00AAFF" }, //结束的颜色
					]),
					new this.$echarts.graphic.LinearGradient(1, 1, 0, 0, [
						{ offset: 0, color: "#47B53E" }, //开始的颜色
						{ offset: 1, color: "#E9FDE8" }, //结束的颜色
					]),
					new this.$echarts.graphic.LinearGradient(1, 1, 0, 0, [
						{ offset: 0, color: "#F38425" }, //开始的颜色
						{ offset: 1, color: "#FFEFE2" }, //结束的颜色
					]),
					new this.$echarts.graphic.LinearGradient(1, 1, 0, 0, [
						{ offset: 0, color: "#3DBDFF" }, //开始的颜色
						{ offset: 1, color: "#3DE5FF" }, //结束的颜色
					]),
					new this.$echarts.graphic.LinearGradient(1, 1, 0, 0, [
						{ offset: 0, color: "#3DBDFF" }, //开始的颜色
						{ offset: 1, color: "#3DE5FF" }, //结束的颜色
					]),
				],
				mainCompany: {
					companyName: "",
					fireAlarm: "",
					planImprovement: 0,
					transmissionState: 0,
					deviceCount: {},
				},
				mainCompanyNum: {},
				// batteryDate: [],
				params: {
					carea: "",
					ccompanyNum: "",
					chartType: 1,
					endTime: "",
					evenClass: 1,
					deviceType: 2,
					startTime: "",
					areaList: [],
					belongProfessionList: [],
					buildTypeHeight: "",
					buildTypeList: [],
					dangerousCapacityList: [],
					safeLevelList: [],
					unitNatureList: [],
					areaPositionFlag: 0,
				},
				params1: {
					carea: "",
					ccompanyNum: "",
					chartType: 1,
					endTime: "",
					evenClass: 1,
					deviceType: 2,
					startTime: "",
					areaList: [],
					belongProfessionList: [],
					buildTypeHeight: "",
					buildTypeList: [],
					dangerousCapacityList: [],
					safeLevelList: [],
					unitNatureList: [],
					areaPositionFlag: 1,
				},
				params2: {
					carea: "",
					ccompanyNum: "",
					chartType: 1,
					endTime: "",
					evenClass: 1,
					deviceType: 2,
					startTime: "",
					areaPositionFlag: "",
				},
				paramsNum: {
					carea: "",
					ccompanyNum: "",
					chartType: 1,
					endTime: "",
					evenClass: 1,
					deviceType: 2,
					startTime: "",
					areaPositionFlag: 0,
				},
				areaCompanyNum: { carea: "", ccompanyNum: "" },
				areaCompanyNum1: { carea: "", ccompanyNum: "" },
				evenClassLoading: false,
				deviceTypeLoading: false,
				loading: false,
				slectedFlag: 2,
				evenFlag: 1,
				bigCcompanyNum: null,
				firstEnter: false,
				onTheMapFlag: true,
				changeJinanQingdao: 0,
				currentPage: 1, //默认页
				pageSize: 10, //每页几条
				countPage: 100,
				tableData: [], //场所数据
				yearsList: [], //维保选择时间值
				dialogVisible: false,
				fireAssessmentTable: [],
				fireAssessmentCountPage: 100,
				fireAssessmentcurrentPage: 1, //默认页
				fireAssessmentpageSize: 10, //每页几条
				searchArr: [],
				clearInputData: false,
			};
		},
		computed: {
			batteryDate: {
				// getter
				get() {
					if (this.onTheMapFlag) {
						return [this.params.startTime, this.params.endTime];
					} else {
						return [this.params1.startTime, this.params1.endTime];
					}
				},
				// setter
				set(newValue) {
					this.evenFlag = 4;
					// console.log(newValue);
					if (newValue == null) {
						console.log("我是清空");

						if (this.onTheMapFlag) {
							[this.params.startTime, this.params.endTime] = ["", ""];
							this.getAlertUnitRank();
						} else {
							[this.params1.startTime, this.params1.endTime] = ["", ""];
							this.getAlertUnitRank1();
						}
					} else {
						newValue[0] += " 00:00:00";
						newValue[1] += " 23:59:59";
						if (this.onTheMapFlag) {
							[this.params.startTime, this.params.endTime] = newValue;
							this.getAlertUnitRank();
						} else {
							[this.params1.startTime, this.params1.endTime] = newValue;
							this.getAlertUnitRank1();
						}
					}

					// this.confirmTime(newValue);
					// console.log(newValue+'213422222222222222');
				},
			},
		},
		watch: {
			isSmall(val) {
				this.key++;
				setTimeout(() => {
					this.getData();
				});
			},
			// "paramsNum.ccompanyNum"(val) {
			//   this.areaCompanyNum.ccompanyNum = val;
			//   this.getkeyPointUnit();
			// },
			"params.ccompanyNum"(val) {
				// log('公司')
				// console.log(val,'公司');
				if (val) {
					this.onTheMapFlag = true;
					this.areaCompanyNum.ccompanyNum = val;
					this.areaCompanyNum.carea = "";
					this.params.areaPositionFlag = 0;

					this.params.evenClass = 1;
					// this.evenFlag =1
					// this.getAlertUnitRank();
					this.getFireAssessment();
					this.getKeyComponyNum();
					if (this.fireFightingFlag) {
						this.getsummaryChart(); //消防评估汇总圆饼图
					} else {
						this.getsummaryChart1(); //消防评估汇总柱状图
					}
					// this.getkeyPointUnit();
					this.getkey();
					this.getsummaryChartList(); //消防评估列表
				}
			},
			"params.carea"(val) {
				// console.log(this.params.areaPositionFlag + "carea");
				// console.log(val,'区域 ');

				if (val) {
					// console.log(val,'区域 ');
					this.onTheMapFlag = true;
					this.areaCompanyNum.carea = val;
					log(this.areaCompanyNum.carea, "carea");
					this.areaCompanyNum.ccompanyNum = "";
					this.params.areaPositionFlag = 0;
					// setTimeout(() => {
					this.params.evenClass = 1;
					// }, 200);
					this.getAlertUnitRank();
					// log('区域')
					this.getKeyComponyNum();

					this.getFireAssessment();
					if (this.fireFightingFlag) {
						this.getsummaryChart(); //消防评估汇总圆饼图
					} else {
						this.getsummaryChart1(); //消防评估汇总柱状图
					}
					// this.getSafetyLevel();
					this.getUnitSafety();
					this.getkey();
					this.getEquipmentDetection();
					this.getsummaryChartList(); //消防评估列表
				}
			},

			"params.evenClass"(val) {
				log(this.params.areaPositionFlag, val, "evenClass");
				this.evenFlag = val;
				if (this.params.areaPositionFlag == 1) {
					log("进来了吗");
					this.params1.evenClass = val;
					// this.params.carea = "";
					// this.params.ccompanyNum = "";
					this.evenClassLoading = true;
					this.getAlertUnitRank1(() => {
						this.evenClassLoading = false;
					});
					// this.evenClassLoading = false;
				} else {
					// log(this.params.carea, "carea111");
					// if (this.onTheMapFlag) {
					this.evenClassLoading = true;
					this.getAlertUnitRank(() => {
						this.evenClassLoading = false;
					});
				}
			},

			"params.deviceType"(val) {
				this.slectedFlag = val;
				log(this.params.deviceType, "deviceType");
				// this.deviceTypeLoading = true;
				this.getEquipmentDetection();
			},
			"params2.deviceType"(val) {
				this.slectedFlag = val;
				this.getEquipmentDetection(true);
			},
			countPage() {
				this.currentPage;
			},

			params: {
				deep: true,
				handler(val) {},
			},
		},
		created() {
			// log(this.shujuchuanshu, 111111111111111);
			this.changeJinanQingdao = this.$store.state.user.userInfo.region;
		},

		mounted() {
			this.firstEnter = true;
			this.getkeyPointUnit();
			this.getData();
		},
		beforeDestroy() {
			clearInterval(timer);
		},
		methods: {
			getData() {
				this.getkey(); //获取总图公司num//重点场所
				this.getAlertUnitRank();
				this.getFireAssessment();
				// this.getSafetyLevel();
				this.getUnitSafety();
				if (this.radarFlag) {
					this.getMaintenance(); //雷达和维保率
				} else {
					this.getMaintenance1();
				}

				this.getEquipmentDetection();
				if (this.fireFightingFlag) {
					this.getsummaryChart(); //消防评估汇总圆饼图
				} else {
					this.getsummaryChart1(); //消防评估汇总柱状图
				}
				this.getKeyComponyNum();
				this.getsummaryChartList(); //消防评估列表页
			},
			// 评估维保调用时间
			changeStartEnd(val, val1) {
				log(val);
				this.yearsList = val;
				if (this.radarFlag) {
					this.getMaintenance(); //雷达和维保率
				} else {
					this.getMaintenance1();
				}
				// this.dialogVisible = false;
			},
			// 弹窗按钮重置，时间重置
			handleClose(done) {
				this.clearInputData = !this.clearInputData;

				log("时间重置");
				this.yearsList = [];
				if (this.radarFlag) {
					this.getMaintenance(); //雷达和维保率
				} else {
					this.getMaintenance1();
				}
				this.dialogVisible = false;
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageSize = val;
				// log(this.onTheMapFlag,'onTheMapFlag')
				if (this.onTheMapFlag) {
					if (this.inputSearch) {
						this.getKeyComponyNum(this.inputSearch);
					} else {
						this.getKeyComponyNum();
					}
				} else {
					console.log(`重置后1`);
					if (this.inputSearch) {
						this.getKeyComponyNum1(this.inputSearch);
					} else {
						this.getKeyComponyNum1();
					}
				}
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val;
				if (this.onTheMapFlag) {
					if (this.inputSearch) {
						this.getKeyComponyNum(this.inputSearch);
					} else {
						this.getKeyComponyNum();
					}
				} else {
					console.log(`重置后2`);
					if (this.inputSearch) {
						this.getKeyComponyNum1(this.inputSearch);
					} else {
						this.getKeyComponyNum1();
					}
				}
			},
			fireHandleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.fireAssessmentpageSize = val;
				log(this.onTheMapFlag, "onTheMapFlag");
				if (this.onTheMapFlag) {
					this.getsummaryChartList();
				} else {
					console.log(`重置后1`);
					this.getsummaryChartList1();
				}
			},
			fireHandleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.fireAssessmentcurrentPage = val;
				if (this.onTheMapFlag) {
					this.getsummaryChartList();
				} else {
					console.log(`重置后2`);
					this.getsummaryChartList1();
				}
			},
			onTheMap(val) {
				this.onTheMapFlag = false;
				// this.evenFlag = 1;
				// console.log(val + "areaPositionFlag444");
				// log(val, "onTheMap");
				// this.params.areaPositionFlag=1
				this.params1.areaPositionFlag = 1;
				// this.params1.ccompanyNum=''
				// this.params1.carea=''
				this.params = this.params1;
				log(this.params, "shuju params");
				log(this.params1, "shuju params1");
				// this.params.evenClass = 1
				// log(val, "onTheMap222");
				// if (this.onTheMapFlag) {
				// this.params.evenClass = 1;
				// } else {
				//   log("地图");
				// this.getAlertUnitRank1();

				// }
				// this.params.areaPositionFlag = 1;
				this.params.evenClass = 1;
				// this.getAlertUnitRank1();
				// this.onTheMap = 0;
			},
			//
			getDateMap(value) {
				log(value, "地图外");

				this.onTheMapFlag = false;
				this.inputSearch = "";
				this.params = {
					carea: "",
					ccompanyNum: "",
					chartType: 1,
					endTime: "",
					evenClass: 1,
					deviceType: 2,
					startTime: "",
					areaList: [],
					belongProfessionList: [],
					buildTypeHeight: "",
					buildTypeList: [],
					dangerousCapacityList: [],
					safeLevelList: [],
					unitNatureList: [],
					areaPositionFlag: 1,
				};
				// this.onTheMap(1);
				this.params.evenClass = 1;
				// this.params.carea=''
				if (value) {
					this.slectedFlag = 2;
					// log(value, 222222222);
					this.getAlertUnitRank1(value); //报警单位排名

					this.getFireAssessment(value); //重点场所，设备在线统计
					// this.getSafetyLevel(value); //单位安全等级分布  有问题
					this.getUnitSafety(value); //单位安全条形图
					if (this.fireFightingFlag) {
						this.getsummaryChart(value); //消防评估汇总圆饼图
					} else {
						this.getsummaryChart1(value); //消防评估汇总柱状图
					}
					this.getkey(value); //重点场所
					this.getKeyComponyNum1();
					this.getEquipmentDetection(value); // 物联设备检测
					this.getsummaryChartList1(); //消防评估列表页
					this.handleClose(); //各区评估维保率时间重置
				}
			},
			// 物联设备检测

			getEquipmentDetection(val) {
				// this.params2, this.areaCompanyNum1
				if (val) {
					// log(val, "物联设备数据2");
					this.$post("things/dataAnalysis/equipmentDetection", Object.assign(this.params2, this.areaCompanyNum1)).then((res) => {
						// log(res, "物联设备数据2 ");
						// if (func) func();
						let xAxisName = [],
							allCount = [],
							offLineCount = [],
							onLineCount = [];
						res.data.forEach((item) => {
							xAxisName.push(item.areaName);
							allCount.push(item.allCount);
							offLineCount.push(item.offLineCount);
							onLineCount.push(item.onLineCount);
						});
						equipmentOption.xAxis[0].data = xAxisName;
						equipmentOption.series[0].data = offLineCount;
						equipmentOption.series[1].data = onLineCount;
						equipmentOption.series[2].data = allCount;
						this.setEquipment(equipmentOption);
					});
				} else {
					log("物联设备检测zou地图");
					this.$post("things/dataAnalysis/equipmentDetection", Object.assign(this.params, this.areaCompanyNum)).then((res) => {
						// log(res, "物联设备数据1 ");
						// if (func) func();
						let xAxisName = [],
							allCount = [],
							offLineCount = [],
							onLineCount = [];
						res.data.forEach((item) => {
							xAxisName.push(item.areaName);
							allCount.push(item.allCount);
							offLineCount.push(item.offLineCount);
							onLineCount.push(item.onLineCount);
						});
						equipmentOption.xAxis[0].data = xAxisName;
						equipmentOption.series[0].data = offLineCount;
						equipmentOption.series[1].data = onLineCount;
						equipmentOption.series[2].data = allCount;
						this.setEquipment(equipmentOption);
					});
				}
			},

			// 报警单位排名
			getAlertUnitRank(func) {
				this.$post("things/dataAnalysis/alertUnitRank", Object.assign(this.params, this.areaCompanyNum)).then((res) => {
					// console.log(res, "排名");
					if (res.code == 121) {
						return;
					} else {
						if (func) func();
						let alertUnitRank = res.data.map((item) => {
							return { name: item.company, value: item.count };
						});
						alertUnitRank = alertUnitRank.reverse();
						let yName = []; // y轴名称
						let maxValue = alertUnitRank[alertUnitRank.length - 1]?.value || 0; //最大值
						let righty = [];
						alertUnitRank.forEach((element) => {
							righty.push(element.value);
							yName.push(element.name);
						});
						batteryBarOoption.yAxis[0].data = yName;
						batteryBarOoption.yAxis[1].data = righty;
						batteryBarOoption.xAxis.max = maxValue;
						batteryBarOoption.series[0].data = alertUnitRank;
						batteryBarOoption.series[1].data = alertUnitRank;
						batteryBarOoption.series[1].symbolBoundingData = maxValue;
						this.setBatteryBar(batteryBarOoption);
					}
				});
			},
			// 报警单位排名初始化
			getAlertUnitRank1(func) {
				this.$post("things/dataAnalysis/alertUnitRank", Object.assign(this.params1, this.areaCompanyNum1)).then((res) => {
					console.log(res, "初始化");

					if (res.code == 121) {
						return;
					} else {
						let alertUnitRank = res.data.map((item) => {
							return { name: item.company, value: item.count };
						});
						alertUnitRank = alertUnitRank.reverse();
						let yName = []; // y轴名称
						let maxValue = alertUnitRank[alertUnitRank.length - 1]?.value || 0; //最大值
						let righty = [];
						alertUnitRank.forEach((element) => {
							righty.push(element.value);
							yName.push(element.name);
						});
						batteryBarOoption.yAxis[0].data = yName;
						batteryBarOoption.yAxis[1].data = righty;
						batteryBarOoption.xAxis.max = maxValue;
						batteryBarOoption.series[0].data = alertUnitRank;
						batteryBarOoption.series[1].data = alertUnitRank;
						batteryBarOoption.series[1].symbolBoundingData = maxValue;
						this.setBatteryBar(batteryBarOoption);
					}
					if (func) func();
				});

				// }
			},
			// 消防评估汇总图数据赋值
			getsummaryChart(value) {
				if (value) {
					// log('青岛')fireAssessmentTable
					if (this.changeJinanQingdao == 1) {
						firePieOption.title[0].text = "青岛消防评估汇总图";
					} else {
						firePieOption.title[0].text = "济南消防评估汇总图";
					}

					this.$post("things/dataAnalysis/summaryChart", this.params1).then((res) => {
						// 点击图标引发血案，重新绘制
						firePieOption.toolbox.feature.myTool1.onclick = () => {
							this.fireFightingFlag = false;

							this.getsummaryChart1();
						};
						firePieOption.series[0].data = [
							{
								value: res.data.buildNotFireScore || 0,
								itemStyle: { color: "#4F7E44" },
								name: "建筑防火得分",
							},
							{
								value: res.data.buildNotFireLoseScore || 0,
								itemStyle: { color: "#779875" },
								name: "建筑防火失分",
							},
							{
								value: res.data.fireFacilitiesScore || 0,
								itemStyle: { color: "#A75D33" },
								name: "消防设施得分",
							},
							{
								value: res.data.fireFacilitiesLoseScore || 0,
								itemStyle: { color: "#AD8D7F" },
								name: "消防设施失分",
							},
							{
								value: res.data.fireSafetyScore || 0,
								itemStyle: { color: "#31559A" },
								name: "消防安全管理得分",
							},
							{
								value: res.data.fireSafetyLoseScore || 0,
								itemStyle: { color: "#5772A6" },
								name: "消防安全管理失分",
							},
						];
						this.setFirePie(firePieOption);
					});
				} else {
					// log('区或者公司')
					this.$post("things/dataAnalysis/summaryChart", this.params).then((res) => {
						firePieOption.toolbox.feature.myTool1.onclick = () => {
							this.fireFightingFlag = false;

							this.getsummaryChart1();
						};
						firePieOption.series[0].data = [
							{
								value: res.data.buildNotFireScore || 0,
								itemStyle: { color: "#4F7E44" },
								name: "建筑防火得分",
							},
							{
								value: res.data.buildNotFireLoseScore || 0,
								itemStyle: { color: "#779875" },
								name: "建筑防火失分",
							},
							{
								value: res.data.fireFacilitiesScore || 0,
								itemStyle: { color: "#A75D33" },
								name: "消防设施得分",
							},
							{
								value: res.data.fireFacilitiesLoseScore || 0,
								itemStyle: { color: "#AD8D7F" },
								name: "消防设施失分",
							},
							{
								value: res.data.fireSafetyScore || 0,
								itemStyle: { color: "#31559A" },
								name: "消防安全管理得分",
							},
							{
								value: res.data.fireSafetyLoseScore || 0,
								itemStyle: { color: "#5772A6" },
								name: "消防安全管理失分",
							},
						];
						this.setFirePie(firePieOption);
					});
				}
			},
			// 消防汇总图柱状图
			getsummaryChart1(value) {
				log(value, "value");
				if (value) {
					firePieOption.title[0].text = "青岛消防评估汇总图";
					this.$post("things/dataAnalysis/summaryChart", this.params1).then((res) => {
						firePieOption1.toolbox.feature.myTool1.onclick = () => {
							this.fireFightingFlag = true;

							this.getsummaryChart();
						};
						let dataNum = res.data;
						let serais;
						let key = Object.keys(dataNum).sort();

						serais = key.map((item) => {
							return dataNum[item];
						});
						serais.forEach((item, index) => {
							if (item == null) {
								serais.splice(index, 1);
							}
						});
						firePieOption1.series[0].data = serais;
						this.setFirePie1(firePieOption1);
					});
				} else {
					this.$post("things/dataAnalysis/summaryChart", this.params).then((res) => {
						// log(res, 555555);
						firePieOption1.toolbox.feature.myTool1.onclick = () => {
							this.fireFightingFlag = true;

							this.getsummaryChart();
						};
						let dataNum = res.data;
						let serais;
						let key = Object.keys(dataNum).sort();

						serais = key.map((item) => {
							return dataNum[item];
						});
						serais.forEach((item, index) => {
							if (item == null) {
								serais.splice(index, 1);
							}
						});
						firePieOption1.series[0].data = serais;
						this.setFirePie1(firePieOption1);
					});
				}
			},
			// 消防评估列表页
			getsummaryChartList() {
				this.$post("/things/dataAnalysis/summaryChartList", this.params).then((res) => {
					// log(res.data,'黄岛')
					// this.fireAssessmentTable=res.data
					//fireAssessmentCountPage
					// log(res.data, "消防评估列表页");
					if (res.data == null) {
						// this.$message({
						//   message: "暂无数据",
						//   type: "warning",
						// });
						// log(this.fireAssessmentcurrentPage,this.fireAssessmentpageSize,this.fireAssessmentCountPage)
						this.fireAssessmentTable = [];
						this.fireAssessmentCountPage = 0;
						return;
					}
					if (this.fireAssessmentcurrentPage == 0) {
						this.fireAssessmentcurrentPage = 1;
					}
					//再次搜索页面值
					const maxPage = Math.ceil(res.data.length / this.pageSize);
					if (this.fireAssessmentcurrentPage > maxPage) {
						this.fireAssessmentcurrentPage = maxPage;
					}
					let dataSlice = res.data.slice((this.fireAssessmentcurrentPage - 1) * this.fireAssessmentpageSize, this.fireAssessmentcurrentPage * this.fireAssessmentpageSize);
					// log(dataSlice, "消防评估列表页");
					let paimingCeil = dataSlice.map((item) => {
						return {
							companyName: item.companyName,
							companyNum: item.companyNum,
							score: item.score,
						};
					});

					this.fireAssessmentTable = paimingCeil;

					this.fireAssessmentCountPage = res.data.length;
				});
			},
			getsummaryChartList1() {
				this.$post("/things/dataAnalysis/summaryChartList", this.params2).then((res) => {
					if (this.fireAssessmentcurrentPage == 0) {
						this.fireAssessmentcurrentPage = 1;
					}
					//再次搜索页面值
					const maxPage = Math.ceil(res.data.length / this.pageSize);
					if (this.fireAssessmentcurrentPage > maxPage) {
						this.fireAssessmentcurrentPage = maxPage;
					}
					// this.fireAssessmentTable=res.data
					//fireAssessmentCountPage
					// log(res.data, "消防评估列表页");
					let dataSlice = res.data.slice((this.fireAssessmentcurrentPage - 1) * this.fireAssessmentpageSize, this.fireAssessmentcurrentPage * this.fireAssessmentpageSize);
					// log(dataSlice, "消防评估列表页");
					let paimingCeil = dataSlice.map((item) => {
						return {
							companyName: item.companyName,
							companyNum: item.companyNum,
							score: item.score,
						};
					});

					this.fireAssessmentTable = paimingCeil;

					this.fireAssessmentCountPage = res.data.length;
				});
			},
			handleEdit(val, val1) {
				log(val, val1, "点击数据");
			},
			// 切换重点场所与搜素单位
			changeBoxContainerFlag() {
				this.boxContainerFlag = !this.boxContainerFlag;
			},
			//切换消防评估与单位
			changeFireAssessmentFlag() {
				this.fireAssessmentFlag = !this.fireAssessmentFlag;
				// this.firePieCharts.resize();
				// this.firePieCharts1.resize()
				if (this.fireFightingFlag) {
					this.getsummaryChart(); //消防评估汇总圆饼图
				} else {
					this.getsummaryChart1(); //消防评估汇总柱状图
				}
			},
			// 重点场所单位列表
			getKeyComponyNum(val) {
				// log('走了吗')
				if (this.onTheMapFlag) {
					this.$post("/things/dataAnalysis/keyPointUnitList", this.params).then((res) => {
						// 搜索
						if (val) {
							if (this.currentPage == 0) {
								this.currentPage = 1;
							}
							// log("搜索", val, 77777777);
							var arr = [];
							let totalDate = res.data;
							for (let i = 0; i < totalDate.length; i++) {
								if (totalDate[i].cname.indexOf(val, 0) >= 0) {
									arr.push(totalDate[i]);
								}
							}

							//再次搜索页面值
							const maxPage = Math.ceil(arr.length / this.pageSize);
							if (this.currentPage > maxPage) {
								this.currentPage = maxPage;
							}
							// this.currentPage=Math.ceil(arr.length / this.pageSize)
							// log(Math.ceil(arr.length / this.pageSize), "arr");
							// log(this.currentPage, "this.currentPage");
							// log(this.pageSize, "this.pageSize");
							let dataSlice = arr.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
							// log(dataSlice, "dataSlice");
							let paimingCeil = dataSlice.map((item) => {
								return {
									areaCode: item.areaCode,
									ccompanyNum: item.ccompanyNum,
									cname: item.cname,
									csafeLevel: item.csafeLevel,
									rankNum: Math.ceil(item.rankNum),
									score: item.score,
									scoreNum: item.scoreNum,
									scoreNumStr: item.scoreNumStr,
								};
							});
							this.tableData = paimingCeil;
							this.countPage = arr.length;
						} else {
							if (this.currentPage == 0) {
								this.currentPage = 1;
							}

							const maxPage = Math.ceil(res.data.length / this.pageSize);
							if (this.currentPage > maxPage) {
								this.currentPage = maxPage;
							}
							// log(res.data.length,this.currentPage,this.pageSize, 8888);
							let dataSlice = res.data.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
							// log(dataSlice, 8888);
							let paimingCeil = dataSlice.map((item) => {
								return {
									areaCode: item.areaCode,
									ccompanyNum: item.ccompanyNum,
									cname: item.cname,
									csafeLevel: item.csafeLevel,
									rankNum: Math.ceil(item.rankNum),
									score: item.score,
									scoreNum: item.scoreNum,
									scoreNumStr: item.scoreNumStr,
								};
							});

							this.tableData = paimingCeil;
							// 页数变化
							// Math.ceil(res.data.length / this.pageSize);

							this.countPage = res.data.length;
						}
					});
				} else {
					if (val) {
						this.getKeyComponyNum1(val);
						log("跳转val");
					} else {
						this.getKeyComponyNum1();
						log("跳转");
					}
				}
			},
			getKeyComponyNum1(val) {
				// log('触发了吗1')
				this.$post("/things/dataAnalysis/keyPointUnitList", this.params2).then((res) => {
					// log(dataSlice, 77777777);
					// 搜索
					if (val) {
						if (this.currentPage == 0) {
							this.currentPage = 1;
						}
						log("搜索", 777777771);
						var arr = [];
						let totalDate = res.data;
						for (let i = 0; i < totalDate.length; i++) {
							if (totalDate[i].cname.indexOf(val, 0) >= 0) {
								arr.push(totalDate[i]);
							}
						}
						const maxPage = Math.ceil(arr.length / this.pageSize);
						if (this.currentPage > maxPage) {
							this.currentPage = maxPage;
						}
						// this.currentPage=Math.ceil(arr.length / this.pageSize)
						let dataSlice = arr.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
						let paimingCeil = dataSlice.map((item) => {
							return {
								areaCode: item.areaCode,
								ccompanyNum: item.ccompanyNum,
								cname: item.cname,
								csafeLevel: item.csafeLevel,
								rankNum: Math.ceil(item.rankNum),
								score: item.score,
								scoreNum: item.scoreNum,
								scoreNumStr: item.scoreNumStr,
							};
						});
						this.tableData = paimingCeil;
						this.countPage = arr.length;
					} else {
						log("数据", 88881);
						if (this.currentPage == 0) {
							this.currentPage = 1;
						}
						const maxPage = Math.ceil(res.data.length / this.pageSize);
						if (this.currentPage > maxPage) {
							this.currentPage = maxPage;
						}
						let dataSlice = res.data.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
						let paimingCeil = dataSlice.map((item) => {
							return {
								areaCode: item.areaCode,
								ccompanyNum: item.ccompanyNum,
								cname: item.cname,
								csafeLevel: item.csafeLevel,
								rankNum: Math.ceil(item.rankNum),
								score: item.score,
								scoreNum: item.scoreNum,
								scoreNumStr: item.scoreNumStr,
							};
						});

						this.tableData = paimingCeil;
						// 页数变化
						// Math.ceil(res.data.length / this.pageSize);

						this.countPage = res.data.length;
					}
				});
			},
			//重点场所,所有公司num
			getkeyPointUnit(value) {
				// 获取每个公司的id
				this.$post("things/dataAnalysis/situationFiveColorMap", this.params).then((res) => {
					this.bigCcompanyNum = res.data.map((item) => {
						return item.ccompanyNum;
					});
					// this.getkey(value);
				});
				// 重点场所接口
				// this.getkey(value);
			},
			// 重点场所接口,第一次进入，点击地图，点击空白处重置
			getkey(value) {
				let i = 0;
				// 点击空白处重置
				if (value) {
					this.getkeyInterface(this.params1, this.areaCompanyNum);
					// this.$post(
					//   "things/dataAnalysis/keyPointUnit",
					//   Object.assign(this.params1, this.areaCompanyNum)
					// ).then((res) => {
					//   this.mainCompanyNum = res.data;
					//   // console.log(this.params1, 11111);
					// });
					clearInterval(timer);

					// timer = setInterval(() => {
					//   i += 1;
					//   this.paramsNum.ccompanyNum = this.bigCcompanyNum[i];
					//   this.getkeyInterface(this.paramsNum)
					// }, 2000);
				} else {
					// 第一次进入
					if (this.firstEnter) {
						this.getkeyInterface(this.paramsNum, this.areaCompanyNum);
						// this.$post(
						//   "things/dataAnalysis/keyPointUnit",
						//   Object.assign(this.paramsNum, this.areaCompanyNum)
						// ).then((res) => {
						//   this.mainCompanyNum = res.data;
						// });

						this.firstEnter = false;
						clearInterval(timer);
						timer = setInterval(() => {
							i += 1;
							this.paramsNum.ccompanyNum = this.bigCcompanyNum[i];
							// console.log(this.paramsNum,22222);
							this.getkeyInterface(this.paramsNum);
							// this.$post("things/dataAnalysis/keyPointUnit", this.paramsNum).then(
							//   (res) => {
							//     this.mainCompanyNum = res.data;
							//     //   console.log(this.paramsNum);
							//   }
							// );
						}, 20000);
						// console.log(timer,2222222222222);
					} else {
						//点击地图
						// console.log(timer,'1111111111111111111111');
						clearInterval(timer);
						this.getkeyInterface(this.paramsNum, this.areaCompanyNum);
						// this.$post(
						//   "things/dataAnalysis/keyPointUnit",
						//   Object.assign(this.paramsNum, this.areaCompanyNum)
						// ).then((res) => {
						//   this.mainCompanyNum = res.data;
						//   // console.log(this.paramsNum);
						// });
					}
				}
			},
			// 重点场所接口单独挑出来
			getkeyInterface(data, data1) {
				this.$post("things/dataAnalysis/keyPointUnit", Object.assign(data, data1)).then((res) => {
					this.mainCompanyNum = res.data;
				});
			},
			//设备在线统计
			getFireAssessment(value) {
				if (value) {
					// log('青岛大图getFireAssessment')
					this.$post("things/dataAnalysis/fireAssessment", Object.assign(this.params1, this.areaCompanyNum1)).then((res) => {
						this.mainCompany = res.data;
						let total = res.data.deviceCount?.deviceCount || 0;
						scaleRingOption.title.text = total;
						scaleRingOption.series[0].data = [];
						let chartData = [
							{
								color: this.scaleRingColorList[2],
								data: res.data.deviceCount?.electricalCount || 0,
								ratio: (res.data.deviceCount?.electricalCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[3],
								data: res.data.deviceCount?.gasCount || 0,
								ratio: (res.data.deviceCount?.gasCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[4],
								data: res.data.deviceCount?.otherCount || 0,
								ratio: (res.data.deviceCount?.otherCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[1],
								data: res.data.deviceCount?.transmissionCount || 0,
								ratio: (res.data.deviceCount?.transmissionCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[0],
								data: res.data.deviceCount?.waterCount || 0,
								ratio: (res.data.deviceCount?.waterCount || 0) / total,
							},
						];
						if (!this.scaleRingCharts)
							chartData.map((item) => {
								if (item.data > 0) {
									let num = Math.round((item.data / total) * 100);
									for (let i = 0; i < num; ++i) {
										scaleRingOption.series[0].data.push(
											{
												value: 5, // 有颜色部分的宽度
												name: i,
												ratio: item.ratio,
												itemStyle: {
													normal: { color: item.color },
												},
											},
											{
												value: 1, // 无颜色部分的宽度
												name: "",
												itemStyle: {
													normal: {
														label: { show: false },
														labelLine: { show: false },
														color: "rgba(0, 0, 0, 0)",
														borderColor: "rgba(0, 0, 0, 0)",
														borderWidth: 0,
													},
												},
											},
										);
									}
								}
							});
						// 如果总数据为0时，每个颜色的值设为25%（本文实现的是四色图），可视具体情况而定
						else {
							chartData.map((item) => {
								if (item.data > 0) {
									let num = Math.round((item.data / total) * 100);
									for (let i = 0; i < num; ++i) {
										scaleRingOption.series[0].data.push(
											{
												value: 5, // 有颜色部分的宽度
												name: i,
												ratio: item.ratio,
												itemStyle: {
													normal: { color: item.color },
												},
											},
											{
												value: 1, // 无颜色部分的宽度
												name: "",
												itemStyle: {
													normal: {
														label: { show: false },
														labelLine: { show: false },
														color: "rgba(0, 0, 0, 0)",
														borderColor: "rgba(0, 0, 0, 0)",
														borderWidth: 0,
													},
												},
											},
										);
									}
								}
							});
						}
						this.setScaleRing(scaleRingOption);
					});
				} else {
					// log('区或者公司getFireAssessment')
					// mainCompany.deviceCount.waterCount
					this.$post(
						"things/dataAnalysis/fireAssessment",
						// "things/dataAnalysis/summaryChart",
						Object.assign(this.params, this.areaCompanyNum),
						// this.params
					).then((res) => {
						// log(res);
						this.mainCompany = res.data;
						let total = res.data.deviceCount?.deviceCount || 0;
						scaleRingOption.title.text = total;
						scaleRingOption.series[0].data = [];
						let chartData = [
							{
								color: this.scaleRingColorList[2],
								data: res.data.deviceCount?.electricalCount || 0,
								ratio: (res.data.deviceCount?.electricalCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[3],
								data: res.data.deviceCount?.gasCount || 0,
								ratio: (res.data.deviceCount?.gasCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[4],
								data: res.data.deviceCount?.otherCount || 0,
								ratio: (res.data.deviceCount?.otherCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[1],
								data: res.data.deviceCount?.transmissionCount || 0,
								ratio: (res.data.deviceCount?.transmissionCount || 0) / total,
							},
							{
								color: this.scaleRingColorList[0],
								data: res.data.deviceCount?.waterCount || 0,
								ratio: (res.data.deviceCount?.waterCount || 0) / total,
							},
						];
						if (!this.scaleRingCharts) {
							chartData.map((item) => {
								if (item.data > 0) {
									let num = Math.round((item.data / total) * 100);
									for (let i = 0; i < num; ++i) {
										scaleRingOption.series[0].data.push(
											{
												value: 5, // 有颜色部分的宽度
												name: i,
												ratio: item.ratio,
												itemStyle: {
													normal: { color: item.color },
												},
											},
											{
												value: 1, // 无颜色部分的宽度
												name: "",
												itemStyle: {
													normal: {
														label: { show: false },
														labelLine: { show: false },
														color: "rgba(0, 0, 0, 0)",
														borderColor: "rgba(0, 0, 0, 0)",
														borderWidth: 0,
													},
												},
											},
										);
									}
								}
							});
						}
						// 如果总数据为0时，每个颜色的值设为25%（本文实现的是四色图），可视具体情况而定
						else {
							chartData.map((item) => {
								if (item.data > 0) {
									let num = Math.round((item.data / total) * 100);
									for (let i = 0; i < num; ++i) {
										scaleRingOption.series[0].data.push(
											{
												value: 5, // 有颜色部分的宽度
												name: i,
												ratio: item.ratio,
												itemStyle: {
													normal: { color: item.color },
												},
											},
											{
												value: 1, // 无颜色部分的宽度
												name: "",
												itemStyle: {
													normal: {
														label: { show: false },
														labelLine: { show: false },
														color: "rgba(0, 0, 0, 0)",
														borderColor: "rgba(0, 0, 0, 0)",
														borderWidth: 0,
													},
												},
											},
										);
									}
								}
							});
						}
						this.setScaleRing(scaleRingOption);
					});
				}
			},
			//单位安全等级分布
			getSafetyLevel(value) {
				if (value) {
					this.$post("things/dataAnalysis/safetyLevel", Object.assign(this.params1, this.areaCompanyNum1)).then((res) => {
						funnelOption.series[0].data = res.data.map((item) => {
							return { name: item.grade + "级", value: item.ratio };
						});
						this.setFunnel(funnelOption);
					});
				} else {
					this.$post("things/dataAnalysis/safetyLevel", Object.assign(this.params, this.areaCompanyNum)).then((res) => {
						// log(res, "单位安全");
						funnelOption.series[0].data = res.data.map((item) => {
							return { name: item.grade + "级", value: item.ratio };
						});
						this.setFunnel(funnelOption);
					});
				}
			},
			// 单位安全条形图
			getUnitSafety(value) {
				if (value) {
					this.$post("things/dataAnalysis/safetyLevel", Object.assign(this.params1, this.areaCompanyNum1)).then((res) => {
						// console.log(res, 33333333333);
						let data = res.data.map((item) => {
							return {
								grade: item.grade,
								ratio: item.ratio,
								furatio: "-" + Number(item.ratio) / 2,
								zhengratio: Number(item.ratio) / 2,
								ratioStr: item.ratioStr,
								color: ["#D43030", "#FF8D1A", "#FFEB3B", "#1AABFF", "#1D9E56"],
							};
						});
						// log(data, "单位安全");
						for (let i = 0; i < data.length; i++) {
							unitSafetyOption.series[2 * i].data[0] = data[i].zhengratio;
							unitSafetyOption.series[2 * i + 1].data[0] = data[i].furatio;
						}

						let a = data.map((item, index) => {
							return (
								`<div>` +
								`<div style="display:inline-block;width:10px;height:10px;border-radius:5px;margin:2px;background-color: ${item.color[index]};"></div>` +
								item.grade +
								"级占比： " +
								item.ratioStr +
								`</div>`
							);
						});
						unitSafetyOption.tooltip.formatter = function(param) {
							return a.join(" ");
						};
						// unitSafetyOption.series[0].data = res.data.map((item) => {
						//   return { name: item.grade + "级", value: item.ratio };
						// });
						this.setFunnel(unitSafetyOption);
					});
				} else {
					this.$post("things/dataAnalysis/safetyLevel", Object.assign(this.params, this.areaCompanyNum)).then((res) => {
						let data = res.data.map((item) => {
							return {
								grade: item.grade,
								ratio: item.ratio,
								furatio: "-" + Number(item.ratio) / 2,
								zhengratio: Number(item.ratio) / 2,
								ratioStr: item.ratioStr,
								color: ["#D43030", "#FF8D1A", "#FFEB3B", "#1AABFF", "#1D9E56"],
							};
						});
						// log(data, "单位安全");
						for (let i = 0; i < data.length; i++) {
							unitSafetyOption.series[2 * i].data[0] = data[i].zhengratio;
							unitSafetyOption.series[2 * i + 1].data[0] = data[i].furatio;
						}

						let a = data.map((item, index) => {
							return (
								`<div>` +
								`<div style="display:inline-block;width:10px;height:10px;border-radius:5px;margin:2px;background-color: ${item.color[index]};"></div>` +
								item.grade +
								"级占比： " +
								item.ratioStr +
								`</div>`
							);
						});
						unitSafetyOption.tooltip.formatter = function(param) {
							return a.join(" ");
						};
						// unitSafetyOption.series[0].data = res.data.map((item) => {
						//   return { name: item.grade + "级", value: item.ratio };
						// });
						this.setFunnel(unitSafetyOption);
					});
				}
			},
			//辖区风险指数雷达图、各区评估维保率
			getMaintenance(value) {
				this.$post(
					"things/dataAnalysis/maintenance",
					Object.assign(this.params2, this.areaCompanyNum1, {
						yearsList: this.yearsList,
					}),
				).then((res) => {
					console.log(res.data, "11111111111111111");
					// radarOption.xAxis.data=[]
					let scoreNum = res.data.areaScoreVOList.map((item) => {
						return item.score;
					});
					let maxScoreNum = Math.max(...scoreNum);
					radiateOption.angleAxis.data = res.data.areaScoreVOList.map((item) => {
						return item.careaName + "\n" + item.score;
					});
					// radarOption.radar.indicator = res.data.areaScoreVOList.map((item) => {
					//   return { name: item.careaName + "\n" + item.score, max: maxScoreNum };
					// });
					let a = res.data.areaScoreVOList.map((item) => {
						return `<div>` + item.careaName + ": " + item.score + `</div>`;
					});
					radiateOption.tooltip.formatter = function(param) {
						return a.join(" ");
					};
					// radarOption.tooltip.formatter = function (param) {
					//   return a.join(" ");
					// };
					radiateOption.toolbox.feature.myTool1.onclick = () => {
						this.radarFlag = false;

						this.getMaintenance1();
					};
					// 点击图标引发血案，重新绘制
					// radarOption.toolbox.feature.myTool1.onclick = () => {
					//   this.radarFlag = false;

					//   this.getMaintenance1();
					// };

					let xData = [],
						series = [
							{
								name: "高危单位的评估率",
								type: "bar",
								barWidth: 10, //柱子宽度
								barGap: 0, //柱子之间间距
								itemStyle: {
									normal: {
										color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
											{
												offset: 0,
												color: "#3BFFFF",
											},
											{
												offset: 1,
												color: "#3BFFFF",
											},
										]),
										barBorderRadius: 3,
									},
								},
								data: [],
							},
							{
								name: "自动系统维保率",
								type: "bar",
								barWidth: 10, //柱子宽度
								barGap: 0, //柱子之间间距
								itemStyle: {
									normal: {
										color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
											{
												offset: 0,
												color: "#006EFF",
											},
											{
												offset: 1,
												color: "#006EFF",
											},
										]),
										barBorderRadius: 3,
									},
								},
								data: [],
							},
						];

					res.data.maintenanceVOList.forEach((item, index) => {
						xData.push(item.areaName);
						series[0].data.push(item.highRiskRatio);
						series[1].data.push(item.ordinaryRatio);

						maintenanceOption.tooltip.formatter = function(params) {
							let str = params[0].axisValue;
							let pinggu = "评估次数为:";
							let weibao = "维保次数为:";
							let a;
							let b;
							// log(params, 222222);
							if (params.length == 1 && params[0].seriesName == "高危单位的评估率") {
								a = res.data.maintenanceVOList[params[0].dataIndex].highRiskNum;
							} else if (params.length == 1 && params[0].seriesName == "自动系统维保率") {
								b = res.data.maintenanceVOList[params[0].dataIndex].ordinaryNum;
							} else {
								a = res.data.maintenanceVOList[params[0].dataIndex].highRiskNum;
								b = res.data.maintenanceVOList[params[1].dataIndex].ordinaryNum;
							}

							params.forEach((item, index) => {
								str =
									str +
									"</br>" +
									`<div style="display: inline-block;width: 10px;height: 10px;margin-right: 3px;border-radius: 5px;background-color:${params[index].color.colorStops[index].color};"></div>` +
									item.seriesName +
									":" +
									item.value +
									"%  " +
									`${item.componentIndex == 0 ? pinggu : weibao}` +
									`${item.componentIndex == 0 ? a : b}` +
									"次";
							});
							return str;
						};
					});

					maintenanceOption.xAxis[0].data = xData;
					maintenanceOption.series = series;
					radiateOption.series[0].data = res.data.areaScoreVOList.map((item) => item.score);
					// radarOption.series.data[0].value = res.data.areaScoreVOList.map(
					//   (item) => item.score
					// );
					this.setRadar(radiateOption);
					// this.setRadar(radarOption);
					this.setMaintenance(maintenanceOption);
				});
			},
			// 辖区风险指数柱状图
			getMaintenance1() {
				// log(this.radarFlag);
				this.$post(
					"things/dataAnalysis/maintenance",
					Object.assign(this.params2, this.areaCompanyNum1, {
						yearsList: this.yearsList,
					}),
				).then((res) => {
					// 维保的
					// log(res.data, "维保的");
					let xData = [],
						series = [
							{
								name: "高危单位的评估率",
								type: "bar",
								// stack: "one",
								barWidth: 10, //柱子宽度
								barGap: 0, //柱子之间间距
								itemStyle: {
									normal: {
										color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
											{
												offset: 0,
												color: "#3BFFFF",
											},
											{
												offset: 1,
												color: "#3BFFFF",
											},
										]),
										barBorderRadius: 3,
									},
								},
								data: [],
							},
							{
								name: "自动系统维保率",
								type: "bar",
								// stack: "one",
								barWidth: 10, //柱子宽度
								barGap: 0, //柱子之间间距
								itemStyle: {
									normal: {
										color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
											{
												offset: 0,
												color: "#006EFF",
											},
											{
												offset: 1,
												color: "#006EFF",
											},
										]),
										barBorderRadius: 3,
									},
								},
								data: [],
							},
						];

					res.data.maintenanceVOList.forEach((item, index) => {
						xData.push(item.areaName);
						series[0].data.push(item.highRiskRatio);
						series[1].data.push(item.ordinaryRatio);

						maintenanceOption.tooltip.formatter = function(params) {
							let str = params[0].axisValue;
							let pinggu = "评估次数为:";
							let weibao = "维保次数为:";
							let a;
							let b;
							// log(params, 222222);
							if (params.length == 1 && params[0].seriesName == "高危单位的评估率") {
								a = res.data.maintenanceVOList[params[0].dataIndex].highRiskNum;
							} else if (params.length == 1 && params[0].seriesName == "自动系统维保率") {
								b = res.data.maintenanceVOList[params[0].dataIndex].ordinaryNum;
							} else {
								a = res.data.maintenanceVOList[params[0].dataIndex].highRiskNum;
								b = res.data.maintenanceVOList[params[1].dataIndex].ordinaryNum;
							}

							params.forEach((item, index) => {
								str =
									str +
									"</br>" +
									`<div style="display: inline-block;width: 10px;height: 10px;margin-right: 3px;border-radius: 5px;background-color:${params[index].color.colorStops[index].color};"></div>` +
									item.seriesName +
									":" +
									item.value +
									"%  " +
									`${item.componentIndex == 0 ? pinggu : weibao}` +
									`${item.componentIndex == 0 ? a : b}` +
									"次";
							});
							return str;
						};
					});

					maintenanceOption.xAxis[0].data = xData;
					maintenanceOption.series = series;
					this.setMaintenance(maintenanceOption);

					// 雷达
					let xdata = [];
					xdata = res.data.areaScoreVOList.map((item) => {
						return item.careaName;
					});
					let serais = res.data.areaScoreVOList.map((item) => {
						return Number(item.score);
					});

					radarOption1.toolbox.feature.myTool1.onclick = () => {
						this.radarFlag = true;

						this.getMaintenance();
					};

					radarOption1.xAxis.data = xdata;
					radarOption1.series[0].data = serais;

					// this.setRadar({});

					this.setRadar1(radarOption1);
					// log('柱状图ceshi')
				});
			},
			setFunnel(option) {
				this.funnelCharts = this.$echarts.init(this.$refs["funnelCharts"]);
				this.funnelCharts.setOption(option);
			},
			setBatteryBar(option) {
				this.batteryBarCharts = this.$echarts.init(this.$refs["batteryBarCharts"]);
				this.batteryBarCharts.setOption(option);
			},
			setRadar(option) {
				this.$echarts.dispose(this.$refs["radarCharts"]);
				this.radarCharts = this.$echarts.init(this.$refs["radarCharts"]);
				this.radarCharts.setOption(option);
			},
			setRadar1(option) {
				this.$echarts.dispose(this.$refs["radarCharts1"]);
				this.radarCharts1 = this.$echarts.init(this.$refs["radarCharts1"]);
				this.radarCharts1.setOption(option);
			},
			setMaintenance(option) {
				this.maintenanceCharts = this.$echarts.init(this.$refs["maintenanceCharts"]);
				this.maintenanceCharts.setOption(option);
			},
			setScaleRing(option) {
				this.scaleRingCharts = this.$echarts.init(this.$refs["scaleRingCharts"]);
				this.scaleRingCharts.setOption(option);
			},
			// 消防评估汇总图初始化显示图
			setFirePie(option) {
				this.$echarts.dispose(this.$refs["firePieCharts"]);
				this.firePieCharts = this.$echarts.init(this.$refs["firePieCharts"]);
				option && this.firePieCharts.setOption(option);

				this.firePieCharts.resize();
			},
			setFirePie1(option) {
				this.$echarts.dispose(this.$refs["firePieCharts1"]);
				this.firePieCharts1 = this.$echarts.init(this.$refs["firePieCharts1"]);
				option && this.firePieCharts1.setOption(option);
				this.firePieCharts1.resize();
			},
			setEquipment(option) {
				this.equipmentCharts = this.$echarts.init(this.$refs["equipmentCharts"]);
				this.equipmentCharts.setOption(option);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.dashboard-container.small {
		// grid-auto-rows: minmax(360px, 33.3%);
		grid-template-columns: repeat(3, minmax(560px, 1fr));
		grid-template-areas:
			"sidebar2 center sidebar5"
			"sidebar3 center sidebar7"
			"sidebar1 sidebar6 sidebar8";
		.area-sidebar4 {
			display: none;
		}
	}
	.dashboard-container {
		overflow: auto;
		align-items: center;
		color: #fff;
		display: grid;
		grid-auto-rows: minmax(426px, 50%);
		grid-template-columns: repeat(5, minmax(560px, 1fr));
		grid-template-areas:
			"sidebar1 sidebar2 center sidebar5 sidebar6"
			"sidebar3 sidebar4 center sidebar7 sidebar8";
		@for $i from 1 through 8 {
			.area-sidebar#{$i} {
				display: inline-block;
				grid-area: sidebar + $i;
			}
			/*css主要部分的样式*/
			/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
		}
		.area-center {
			display: inline-block;
			grid-area: center;
			height: 100%;
		}
		.box-content {
			background: url("~@/assets/img/analysis/box-content.png") no-repeat;
			background-size: 100% auto;
			padding: 16px 68px 32px;
			aspect-ratio: 3/2;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			position: relative;
			*::-webkit-scrollbar {
				display: none;
			}

			.box-more {
				cursor: pointer;
				position: absolute;
				right: 24px;
				/** 文本1 */
				font-size: 16px;
				font-weight: 500;
				color: rgba(255, 255, 255, 1);
				right: 84px;
				top: 28px;
			}
			.box-header {
				background: url("~@/assets/img/analysis/box-header.png") no-repeat;
				height: 32px;
				margin: 12px 10px;
				padding-left: 48px;
				font-size: 24px;
				font-weight: 400;
				letter-spacing: 0.48px;
				line-height: 20px;
				color: rgb(218, 244, 255);
			}
			.box-header1 {
				background: url("~@/assets/img/analysis/box-header.png") no-repeat;
				height: 32px;
				margin: 12px 10px;
				display: flex;
				justify-content: space-between;

				span {
					padding-left: 48px;
					font-size: 24px;
					font-weight: 400;
					letter-spacing: 0.48px;
					line-height: 20px;
					color: rgb(218, 244, 255);
				}
			}
			.box-container {
				flex: 1;
				overflow: auto;
				display: flex;
				flex-direction: column;
			}
			// ::v-deep .el-picker-panel .el-date-range-picker .el-popper .has-time{
			//   z-index: 999999999;
			// }
			.box-containerSearch {
				// flex: 1;
				// overflow: auto;
				// display: flex;
				// flex-direction: column;
				// 输入框样式
				::v-deep .el-input__inner {
					// opacity: 0.3;
					width: 60%;
					height: 35px;
					color: #fff;
					background-color: transparent;
				}
				::v-deep .el-table th.is-leaf {
					/* 去除上边框 */
					border: none !important;
				}
				::v-deep .el-table td {
					/* 去除上边框 */
					border: none !important;
				}
				// .my-table td,
				// .my-table th.is-leaf {
				//   border: none;
				// }
				// 表格样式
				.regional_table ::v-deep .el-table,
				.regional_table ::v-deep .el-table__expanded-cell {
					background-color: transparent;
					color: white;
				}
				/* 表格内背景颜色 */
				.regional_table ::v-deep .el-table th,
				.regional_table ::v-deep .el-table tr,
				.regional_table ::v-deep .el-table td {
					background-color: transparent !important;
					//表格字体颜色
					color: white;
				}
				::v-deep .el-pagination .btn-next {
					background-color: transparent;
				}
				::v-deep .el-pagination .btn-prev {
					background-color: transparent;
				}
				// .tableBg {
				//   background-color: rgba(255, 255, 255, 0.247);
				// }
				// ::v-deep .el-table_1_column_1 {
				//   background-color: rgba(255, 255, 255, 0.247);
				// }
				// 分页样式
				::v-deep {
					.el-pager li {
						border-radius: 50px;
						margin: 0 3px;
					}
					.el-pager li.active {
						color: #fff;
						background-color: rgb(124, 162, 243);
					}
					.el-pagination button:disabled {
						color: #333;
						background-color: white;
					}
					.el-pagination .btn-prev {
						background-color: white;
						border-radius: 50px;
					}
					.el-pagination .btn-next {
						background-color: white;
						border-radius: 50px;
					}
				}
			}
			.fireList {
				.regional_table ::v-deep .el-table,
				.regional_table ::v-deep .el-table__expanded-cell {
					background-color: transparent;
					color: white;
				}
				/* 表格内背景颜色 */
				.regional_table ::v-deep .el-table th,
				.regional_table ::v-deep .el-table tr,
				.regional_table ::v-deep .el-table td {
					background-color: transparent !important;
					//表格字体颜色
					color: white;
				}
				::v-deep .el-pagination .btn-next {
					background-color: transparent;
				}
				::v-deep .el-pagination .btn-prev {
					background-color: transparent;
				}
				::v-deep {
					.el-pager li {
						border-radius: 50px;
						margin: 0 3px;
					}
					.el-pager li.active {
						color: #fff;
						background-color: rgb(124, 162, 243);
					}
					.el-pagination button:disabled {
						color: #333;
						background-color: white;
					}
					.el-pagination .btn-prev {
						background-color: white;
						border-radius: 50px;
					}
					.el-pagination .btn-next {
						background-color: white;
						border-radius: 50px;
					}
				}
			}
			.half {
				height: 100%;
				width: 50%;
			}
		}
	}

	.box-title {
		font-size: 36px;
		font-weight: 700;
		color: rgba(236, 249, 255, 1);
	}
	.box-text {
		/** 文本1 */
		font-size: 20px;
		font-weight: 700;
		color: rgba(236, 249, 255, 1);
		span {
			font-size: 30px;
		}
	}
	.yellow {
		color: rgba(255, 235, 59, 1);
	}
	.dark-yellow {
		color: rgba(255, 215, 37, 1);
	}
	.baby-blue {
		color: rgba(15, 248, 253, 1);
	}
	.three {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
	}
	.safe-legend {
		position: absolute;
		left: 0;
		display: grid;
		grid-auto-rows: 35px;
		grid-gap: 10px;
		color: #ffffff;
		font-size: 16px;
		font-weight: 400;
		margin-top: 15px;
		div {
			padding: 0 12px;
			display: flex;
			align-items: center;
			background: linear-gradient(270deg, #06305a 0%, #0e6dcc 100%);
		}
		$colors: #862536, #935829, #a49d3c, #009dff, #1d9e56;

		@each $c in $colors {
			$i: index($colors, $c); // 获取 $c 在数组中的索引，并赋值给 $i 赋值用冒号，不是等号~！
			.legend-text-color#{$i} {
				margin-left: 12px;
				color: $c;
			}
		}
	}
	.ring-right {
		display: grid;
		grid-auto-rows: 45px;
		justify-content: space-around;
		align-items: center;
		gap: 10px;
	}
	.ring-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.ring-label {
		align-items: center;
		/** 文本1 */
		font-size: 18px;
		font-weight: 400;

		color: #daf4ff;

		$colors: #168dd8, #45b43c, #f38322, #1fcef0, #1fcef1;

		@each $c in $colors {
			$i: index($colors, $c); // 获取 $c 在数组中的索引，并赋值给 $i 赋值用冒号，不是等号~！
			.ring-color#{$i} {
				margin-right: 12px;
				background: $c;
			}
		}
		.ring-box {
			width: 10px;
			height: 10px;
		}
	}
	.ring-text {
		/** 文本1 */
		margin-top: -5px;
		margin-left: 14px;
		font-size: 16px;
		font-weight: 400;
		color: #daf4ff;

		$colors: -webkit-linear-gradient(bottom, #00aaff, #e4fbff), -webkit-linear-gradient(bottom, #47b53e, #e9fde8), -webkit-linear-gradient(bottom, #f38425, #ffefe2),
			-webkit-linear-gradient(bottom, #3dbdff, #3de5ff), -webkit-linear-gradient(bottom, #3dbdff, #3de5f1);
		@each $c in $colors {
			$i: index($colors, $c); // 获取 $c 在数组中的索引，并赋值给 $i 赋值用冒号，不是等号~！
			.ring-text-color#{$i} {
				/** 文本1 */
				font-size: 24px;
				font-weight: 700;
				background-image: $c;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
	}
	.battery-header {
		display: flex;
		// grid-template-columns: repeat(auto-fill, 110px);
		span {
			width: 100px;
			text-align: center;
			border-radius: 0px 0px 9px 9px;
			background: rgba(91, 102, 135, 1);
			cursor: pointer;
		}
	}
	.battery-charts-header {
		display: flex;
		margin: 5px 12px;
		span {
			/** 文本1 */
			width: 150px;
			font-size: 18px;
			font-weight: 500;
			color: rgba(255, 255, 255, 1);
		}
	}
	.deviceSlected {
		background-color: rgb(235, 12, 12);
	}
	#zong::-webkit-scrollbar {
		display: block !important;
	}
</style>
